/**
 * F17 target-language picker options. There is no `language.list`-shaped WS
 * op / language catalog in the frozen M3 contract to source this from — the
 * only BCP-47 authority in `@xdocs/schemas`/`@xdocs/i18n` today is
 * `LOCALES` (`en`/`ro`, the APP UI locale set, a much narrower thing than
 * "every language a document can be translated into"). This is a curated
 * placeholder set of common target languages until a real catalog/op lands.
 * Labels are each language's own native name (conventional for a language
 * picker — a language name is not itself translated by the app's locale).
 *
 * OPEN ISSUE: replace with a server-sourced language catalog (WS-TRANS
 * ownership) once one exists.
 */
export interface TranslateLanguageOption {
  code: string; // BCP-47
  label: string;
}

export const TRANSLATE_LANGUAGE_OPTIONS: readonly TranslateLanguageOption[] = [
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'pt', label: 'Português' },
  { code: 'ro', label: 'Română' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'pl', label: 'Polski' },
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '中文' },
  { code: 'ar', label: 'العربية' },
  { code: 'hi', label: 'हिन्दी' },
];
